import {UmpireStage} from '../umpire-stage';

export interface UmpireGroup {
  type: string;

  id: string;

  name: string | null;

  stage: UmpireStage;

  slug: string | null;
}
